{
  "version": 1,
  "asset_id": "4f97a6a5-84e3-4838-8d6e-bbdc891b7cd0",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/4f97a6a5-84e3-4838-8d6e-bbdc891b7cd0/logo_m.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/4f97a6a5-84e3-4838-8d6e-bbdc891b7cd0/logo_m.png",
  "original_filename": "logo_m.png",
  "size": 5528,
  "content_type": "image/png",
  "created_at": "2026-07-10T13:31:21Z"
}
